import { useTranslation } from 'contexts/Localization'
import { Text } from 'vvs-uikit'
import useGotchiOwner from 'state/vvsgotchi/hooks/useGotchiOwner'
import useEndOfUTCDayCountdown from 'hooks/useEndOfUTCDayCountdown'

const FeedAgainCountdown = () => {
  const { t } = useTranslation()
  const { refresh } = useGotchiOwner()
  const timeExcerptMap = useEndOfUTCDayCountdown(refresh)

  return (
    <Text color="black" fontSize="13px" textAlign="left">
      {t('Reset in %untilResetTime%', {
        untilResetTime: timeExcerptMap.h > 0 ? t('%h%hr %m%m', timeExcerptMap) : t('%m%m', timeExcerptMap),
      })}
    </Text>
  )
}

export default FeedAgainCountdown
